module.exports = __webpack_public_path__ + "static/sicredi_logo-6fab2c170e326226cde8bdb01648c45f.png";